import React, { useEffect, useRef, useState, useMemo } from "react";
import { ControlLabel } from "react-bootstrap";
import qs from 'qs';

const Preview = ({event, settings, params}) => {
    const ref = useRef();
    const [iframeHeight, setIframeHeight] = useState('400px');

    function onWidgetLoad() {
        setTimeout(() => {
            setIframeHeight(`${ref.current.contentWindow.document.body.scrollHeight}px`);
        }, 1000);
    };

    useEffect(() => {
        ref.current.contentWindow.postMessage({
            widgetSettings: settings,
        }, '*');
    }, [settings]);

    useEffect(() => {
        const messageHandler = (event) => {
            if (ref.current.contentWindow !== event.source) {
                return;
            }
            try {
                let data = typeof event.data === 'string' ? JSON.parse(event.data) : event.data;
                if (!data) {
                    return;
                }

                if (data.hasOwnProperty('setHeight')) {
                    ref.current.height = data.setHeight + 'px';
                }
            } catch (error) {
                console.error(error);
            }
        };

        window.addEventListener('message', messageHandler);

        return () => {
            window.removeEventListener('message', messageHandler);
        }
    }, []);

    const query = useMemo(() => qs.stringify(params, { skipNulls: true, encode: false }), [params]);

    return (
        <div>
            <ControlLabel>
                Виджет Плеер
            </ControlLabel>
            <iframe
                ref={ref}
                src={`/widget/${event.eventKey}/broadcast?${query}`}
                width="100%"
                height={iframeHeight}
                frameBorder="0"
                scrolling="no"
                allowFullScreen={true}
                onLoad={onWidgetLoad}
            />
        </div>
    );
};

export default Preview;
